<template>
    
    <div class="div-barra-navegacao">
        <div class="div-esquerda"><button @click="anterior"><i class="fas fa-angle-left"></i></button></div>
        <div class="div-centro"><slot></slot></div>
        <div class="div-direita"><button @click="proximo"><i class="fas fa-angle-right"></i></button></div>
    </div>

</template>

<script>
export default {
    name : 'BarraNavegacao',

    methods :{
        proximo(){
            this.$emit('proximo');
        }, 
        anterior(){
            this.$emit('anterior');
        }

    }
    
}
</script>

<style scoped>

    button{
        color: white;
        font-size: 24px;
        background: var(--primary-color);
        border: 0px;
        width: calc(100% - 2px);
        height: 50px;
        text-align: center;
        outline: none;
    }

    .div-barra-navegacao{
        display: table;
        height: 50px;
        background: var(--primary-color);
        width: 100%;
    }

    .div-esquerda{
        float: left;
        width: 20%;
        
    }

    .div-centro{
        float: left;
        width: 58%;
    }
    .div-direita{
        float: right;
        width: 20%;
    }

</style>